import * as React from 'react';
import { SourceType } from "../../store/ExternalEpmConnectStore";
import { Dictionary, ISourceInfo, SourceInfo } from "../../entities/common";
import { Integrations, PPMFeatures, Subscription } from '../../store/Tenant';
import { RendersMap, TabConnectControl } from './TabConnectControl';
import SystemsList from './SystemsList';

type Props = {
    rendersMap: RendersMap;
    subscription: Subscription;
    readonly: boolean;
    actions: Dictionary<Dictionary<any>>;
    onDismiss: () => void;
    sourceInfos: ISourceInfo[];
    hiddenOptions?: SourceType[];
    onShowContactUsDialog?: () => void;
};

const externalSystems = [SourceType.VSTS, SourceType.Jira, SourceType.P4W, SourceType.O365Planner,
    SourceType.Spo, SourceType.MPPFile, SourceType.Smartsheet, SourceType.MondayCom, SourceType.File
];

const LinkTab = (props: Props) => {
    const integrations = React.useMemo(() => new Integrations(props.subscription.integrations), [props.subscription.integrations]);
    const connectedSystems = React.useMemo(() => 
        SourceInfo.getSources(props.sourceInfos).filter(_ => !props.hiddenOptions?.includes(_.type)).map(_ => _.type),
        [props.sourceInfos]
    );
    const avaliableExternalSystems = externalSystems.filter(_ => !props.hiddenOptions?.includes(_));
    const systems = React.useMemo(() => avaliableExternalSystems.map(_ => ({ 
        type: _, 
        isConnected: connectedSystems.indexOf(_) > -1,
        isUnavailable: integrations?.isDisabled(_) || (_ === SourceType.MPPFile && !Subscription.contains(props.subscription, PPMFeatures.IntegrationAPI))
    })), [connectedSystems]);
    const [system, setSystem] = React.useState<SourceType>(connectedSystems[0] ?? avaliableExternalSystems[0]);
    return <>
        <SystemsList selectedSystem={system} systems={systems} onSelect={setSystem} />
        {system !== undefined && <TabConnectControl
            {...props}
            connector={system}
            rendersMap={props.rendersMap}
            subscription={props.subscription}
        />}
    </>;
}
export default LinkTab;